import cn from 'classnames';
import { string } from 'prop-types';
import { IonIcon } from '@ionic/react';

import styles from './styles.module.scss';
import { typeWarningClasses, defaultTypeWarning } from './constants';

const WarningMessage = ({ icon, text, typeWarning, classes, fontClass }) => {
  const typeWarningClass = typeWarningClasses[typeWarning || defaultTypeWarning];
  return (
    <div className={cn('row middle full-width m-top-2', styles.warningContainer, typeWarningClass, classes)}>
      {icon && <IonIcon className={cn('m-right-2', styles.textWarning, styles.icon)} icon={icon} />}
      <span className={`${fontClass} ${styles.text}`}>{text}</span>
    </div>
  );
};

WarningMessage.propTypes = {
  text: string.isRequired,
  classes: string,
  fontClass: string,
  icon: string,
  typeWarning: string
};

export default WarningMessage;
